import React from 'react'
import { ImageOptimization } from '@components/image-optimization'

interface ModalProps {
  className?
  showModal: boolean
  setShowModal: (value) => void
  children?: React.ReactNode
}

const Modal: React.FC<ModalProps> = ({ children, showModal, setShowModal }) => {
  const onClose = () => {
    setShowModal(false)
  }

  return (
    showModal && (
      <>
        <div
          className="overflow-x-hidden w-full h-full md:flex md:justify-center md:items-center md:px-5 md:py-5 lg:p-0
            overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none px-4"
        >
          <div className="justify-center items-center flex h-full">
            <div className="rounded-md shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div
                className="flex items-center justify-center absolute top-4 cursor-pointer right-4 p-1 shadow-md bg-orange rounded-full w-10 h-10 z-10 md:w-7 md:h-7 md:-top-3 md:-right-3"
                onClick={() => onClose()}
              >
                <button className="text-black font-bold" type="button">
                  <ImageOptimization
                    src="/assets/close.svg"
                    height={26}
                    width={26}
                  />
                </button>
              </div>
              <div className="relative p-4 lg:p-0 flex-auto">{children}</div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  )
}

export default Modal
